export const buildCompetitionCompareUrl = (competitors, activeWebsiteId, extraParams = {}) => {
  if (!competitors) {
    const params = buildQueryParams([], extraParams);
    return params ? `/competition/compare?${params}` : '/competition/compare';
  }

  const competitorsArray = Array.isArray(competitors)
    ? competitors
    : Object.values(competitors);

  const competitorIds = competitorsArray
    .filter((competitor) => competitor && competitor.id !== activeWebsiteId)
    .map((competitor) => competitor.id);

  const params = buildQueryParams(competitorIds, extraParams);

  return params ? `/competition/compare?${params}` : '/competition/compare';
};

const buildQueryParams = (competitorIds, extraParams) => {
  const queryParams = new URLSearchParams();

  if (competitorIds.length > 0) {
    queryParams.set('competitors', competitorIds.join(','));
  }

  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.set(key, value);
    }
  });

  return queryParams.toString();
};

